/**
 * Quotation / job card (docs/pospak-business-fit-audit.md — vehicle
 * decoration and other job-based service businesses had no way to price and
 * hand over an estimate before work starts). Deliberately similar shape to
 * `addBillLineSchema` — a quote line is priced the same way a bill line is,
 * so converting one to the other is a straight mapping, not a translation.
 */
import { z } from 'zod';
import { idSchema, paginationSchema, paisaSchema, positiveQtyMilliSchema } from './common.js';
export const QUOTATION_STATUSES = ['DRAFT', 'SENT', 'ACCEPTED', 'REJECTED', 'CONVERTED', 'EXPIRED', 'CANCELLED'];
export const quotationLineInputSchema = z.object({
    variantId: idSchema,
    qtyMilli: positiveQtyMilliSchema,
    /** Omit to price from the catalog; a job quote very often overrides this (custom labor pricing). */
    unitPricePaisa: paisaSchema.optional(),
    discountPaisa: paisaSchema.min(0).default(0),
});
export const createQuotationSchema = z.object({
    shopId: idSchema,
    customerId: idSchema.nullable().optional(),
    customerName: z.string().max(120).optional(),
    customerPhone: z.string().max(20).optional(),
    vehicleOrJobRef: z.string().max(120).optional(),
    notes: z.string().max(1000).optional(),
    validUntilDate: z.coerce.date().optional(),
    lines: z.array(quotationLineInputSchema).min(1),
});
export const updateQuotationSchema = z.object({
    customerId: idSchema.nullable().optional(),
    customerName: z.string().max(120).optional(),
    customerPhone: z.string().max(20).optional(),
    vehicleOrJobRef: z.string().max(120).optional(),
    notes: z.string().max(1000).optional(),
    validUntilDate: z.coerce.date().nullable().optional(),
    lines: z.array(quotationLineInputSchema).min(1).optional(),
});
export const setQuotationStatusSchema = z.object({
    status: z.enum(QUOTATION_STATUSES),
});
export const listQuotationsQuerySchema = paginationSchema.extend({
    shopId: idSchema.optional(),
    status: z.enum(QUOTATION_STATUSES).optional(),
});
//# sourceMappingURL=quotations.js.map